export default __webpack_public_path__ + "static/thumbs-up-6e747494410de9545a995faca437c633.gif";